import React from "react";
import { Heading, Link } from "@telia/teddy";

const BestillSim: React.FC = () => (
    <div className="retailer-dashboard-wrapper">
        <Heading mb="100" as="h1" variant="title-300">
            Bestill SIM kort og materiell
        </Heading>
        <p>
            <Link
                href="https://telia.logistikkhuset.no/"
                target="_blank"
                rel="noopener noreferrer"
                variant="standalone"
            >
                Åpne bestillingsportalen (Logistikkhuset) - i ny fane
            </Link>
        </p>
    </div>
);

export default BestillSim;
